import { useMemo } from 'react';

import { DeliveryType } from 'weborder/Api';

import { OrderHistoryData } from '../core/state/order/order.types';
import { getFilteredOrderHistory } from '../utils/orderUtils';

type UseReorderList = {
  reorderList: OrderHistoryData[];
  showReorder: boolean;
};

export const useReorderList = (
  deliveryType: DeliveryType,
  isOrderHistoryEmpty: boolean,
  isOrderHistoryError: boolean,
  isOrderHistoryLoading: boolean,
  isOrderHistorySuccess: boolean,
  previousOrders: OrderHistoryData[],
  physicalRestaurantId?: number,
): UseReorderList => {
  const filteredOrders = useMemo(
    () =>
      isOrderHistorySuccess && !isOrderHistoryEmpty
        ? getFilteredOrderHistory(
            previousOrders,
            deliveryType,
            3,
            physicalRestaurantId,
          )
        : [],
    [isOrderHistorySuccess, deliveryType, physicalRestaurantId],
  );

  const showReorder =
    isOrderHistoryLoading ||
    (!isOrderHistoryError &&
      !(isOrderHistorySuccess && filteredOrders.length === 0));

  return {
    reorderList: filteredOrders,
    showReorder,
  };
};
